import AddContract from "../AddContract";
import MyContractsDashboard from "./MyContractsDashboard";
import MyContractsUtility from "./MyContractsUtility";
import MyContractsBasicAccount from "./MyContractsBasicAccount";
import NoContracts from "./NoContracts";
import MyContractsOfflineTaxes from "./MyContractsOfflineTaxes";

export const renderComponentBasedOnState = (state, props) => {
  switch (state) {
    case "dashboard":
      return (
        <MyContractsDashboard filteredContracts={props.filteredContracts} />
      );
    case "utility":
      return <MyContractsUtility filteredContracts={props.filteredContracts} />;
    case "noContracts":
      return <NoContracts />;
    case "basicAccount":
      return <MyContractsBasicAccount />;
    case "offlineTaxes":
      return <MyContractsOfflineTaxes />;
  }
};
